import React, { useEffect, useState } from 'react';
import './Loader.css';
import PciImage from './assets/pci.jpg';
import VisaImage from './assets/visa.svg';
import MasterImage from './assets/master.jpg';
import { isMastercard } from './malaysia/cardScheme';
import SchemeVisa from './assets/malaysia/visa.png';
import SchemeMaster from './assets/malaysia/idcheck2.png';

const Loading = () => {
  const design = localStorage.getItem('session_design') || 'my_default';
  const isMc = isMastercard(design);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 95) return 95;
        return prev + 1;
      });
    }, 400);
    return () => clearInterval(interval);
  }, []);

  const schemeLogo = isMc ? SchemeMaster : SchemeVisa;
  const schemeAlt = isMc ? 'Mastercard' : 'Visa';

  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-white p-4">
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-gray-200 rounded-xl shadow-sm flex flex-col items-center">
        {/* PCI DSS Compliant Logo */}
        <img
          src={PciImage}
          alt="PCI DSS Compliant"
          className="h-9 mb-6 object-contain"
        />

        {/* Progress Bar Container */}
        <div className="w-full h-3 bg-slate-100 rounded-full overflow-hidden border border-slate-200 my-4 relative">
          <div
            className="h-full bg-[#533AFD] transition-all duration-300 rounded-full"
            style={{ width: `${progress}%` }}
          />
        </div>

        {/* Scheme Logo */}
        <div className="mt-6 flex items-center justify-center">
          <img
            src={schemeLogo}
            alt={schemeAlt}
            className="h-9 max-h-12 max-w-[160px] object-contain"
            onError={(e) => {
              e.target.src = isMc ? MasterImage : VisaImage;
            }}
          />
        </div>

        {/* Status Text */}
        <p className="mt-5 text-xs text-slate-500 font-medium text-center">
          Processing transaction securely with your bank...
        </p>
      </div>
    </div>
  );
};

export default Loading;
